import Page from '../page';

import moduleInvestorsAdvisersHero from '../../module/investors/advisers/hero';
import moduleInvestorsAdvisersList from '../../module/investors/advisers/list';

import jumpFactory from '../../libs/jump/jump';
import binder from '../../libs/utils/binder';
import router from '../../libs/router/router';

interface ExtInvestorsAdvisersPageConfigInterface {
	cssId: {
		headerCls: string;
		layout: {
			navigateTargetId: string;
			canNavigateCls: string;
			headerMenuItemCls: string;
			headerMenuItemActiveCls: string;
		};
	};
	startModule: string;
	startModuleSlug: string;
	baseUrl: string;
	currentUrl: string;
	moduleHeroConfig?: ConfigInterface;
	moduleListConfig?: ConfigInterface;
	trackAdd?: {
		[key: string]: string;
	};
}

interface ConfigInterface {
	cssId: {
		[key: string]: string;
	},
	slug: string;
	trackAdd?: {};
}

interface ServiceInterface {
	jump?: ReturnType<typeof jumpFactory.create>;
}

interface ItemsInterface {
	init: boolean;
	module: (typeof moduleInvestorsAdvisersHero) | (typeof moduleInvestorsAdvisersList);
	config: ConfigInterface;
	callbacks: {};
}

declare global {
	interface Window {
		extInvestorsAdvisersPageConfig: ExtInvestorsAdvisersPageConfigInterface;
	}
}

class InvestorsAdvisersPage extends Page {

	publicVars: ExtInvestorsAdvisersPageConfigInterface;
	service: ServiceInterface = {};

	privateVars: {
		items: Map<string, ItemsInterface>;
		itemsKeys: string[];
		canNavigateAction: (0 | 1);
		targetSection: string;
		currentMenuItem: string;
	} = {
		items: new Map(),
		itemsKeys: [],
		canNavigateAction: 0,
		targetSection: '',
		currentMenuItem: ''
	};

	constructor() {
		super('InvestorsAdvisersPage');
		this.publicVars = window['extInvestorsAdvisersPageConfig'];
		this.privateVars.canNavigateAction = 0;
		this.privateVars.currentMenuItem = this.publicVars.startModule;
	}

	startup() {
		this.msg('startup');

		this.service.jump = jumpFactory.create();
		this.service.jump.init();

		this.privateVars.items = new Map();

		if (this.publicVars.moduleHeroConfig) {
			this.privateVars.itemsKeys.push('investors-advisers__hero');

			this.privateVars.items.set('investors-advisers__hero', {
				init: false,
				module: moduleInvestorsAdvisersHero,
				config: this.publicVars.moduleHeroConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleListConfig) {
			this.privateVars.itemsKeys.push('investors-advisers__list');

			this.privateVars.items.set('investors-advisers__list', {
				init: false,
				module: moduleInvestorsAdvisersList,
				config: this.publicVars.moduleListConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.startModule !== '' && this.publicVars.startModule !== 'investors-advisers__hero') {
			this.performNavigate(this.publicVars.startModule, {
				fireAnim: 1
			});
		} else {
			this.handleCurrentScrollPosition();
		}
	}

	bind() {
		this.msg('bind');

		let ticking = false;

		window.addEventListener('beforeunload', (e)=> {
			//alert('abc');
			//view.privateVars.canNavigateAction = 1;

			if (this.privateVars.currentMenuItem != 'investors-advisers__hero' && this.privateVars.currentMenuItem != '') {

				const elementHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + this.privateVars.currentMenuItem) as HTMLElement;
				const headerElementHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

				const elementPos = elementHtml.getBoundingClientRect();
				const headerPos = headerElementHtml.getBoundingClientRect();

				window.scroll(0, elementPos.top + window.scrollY - headerPos.height);
			}
		});

		window.addEventListener('scroll', () => {
			if (this.privateVars.canNavigateAction === 0) {
				if (!ticking) {
					window.requestAnimationFrame(() => {
						this.handleCurrentScrollPosition();
						ticking = false;
					});
				}
				ticking = true;
			}
		});

		window.addEventListener('resize', () => {
			this.handleCurrentScrollPosition();
		});

		window.addEventListener('orientationchange', () => {
			this.handleCurrentScrollPosition();
		});

		binder.bindToAll('click', this.publicVars.cssId.layout.canNavigateCls, (e: Event) => {
			e.preventDefault();

			const element = e.currentTarget as HTMLElement;
			const target = element.dataset.target;

			this.msg('navigate target ' + target);

			if(target) {
				this.performNavigate(target, { fireAnim: 1 });
			}
		});
	}

	handleCurrentScrollPosition(options?: {
		target?: string;
	}) {
		const systemCurrentScroll = document.documentElement.scrollTop || window.scrollY;

		let currentMenu;

		const cssHeaderHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;
		const cssHeaderHeight = cssHeaderHtml.offsetHeight;

		let continueFindMenuItem = true;
		let lastItemOffsetHeight = 0;

		for (let [key, _value] of this.privateVars.items) {

			let cssNavigateTargetHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + key);

			if(!cssNavigateTargetHtml) {
				this.errorMsg('navigate target not found ' + key);
				continue;
			}

			let targetPos = {
				top: cssNavigateTargetHtml.getBoundingClientRect().top + window.scrollY,
				left: cssNavigateTargetHtml.getBoundingClientRect().left + window.scrollX
			};

			this.handleModuleInit(systemCurrentScroll, key, targetPos);

			if (continueFindMenuItem) {
				if (systemCurrentScroll === 0) {
					currentMenu = key;
					continueFindMenuItem = false;
				} else {

					const windowHeight = window.innerHeight;

					let modifierDivisionValue = (lastItemOffsetHeight > windowHeight) ? windowHeight : lastItemOffsetHeight;

					let modifier = modifierDivisionValue / 2;

					if ((targetPos.top - cssHeaderHeight - modifier) < systemCurrentScroll) {
						currentMenu = key;
					}
				}
			}

			const targetElementHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + key) as HTMLElement;

			lastItemOffsetHeight = targetElementHtml.offsetHeight;
		}

		if (options && options.target) {
			currentMenu = options.target;
		}

		// if (this.privateVars.currentMenuItem !== currentMenu) {
		//
		// 	if(this.privateVars.currentMenuItem !== '' && this.privateVars.currentMenuItem !== 'home__hero') {
		// 		const oldHeaderMenuItemHtml = document.querySelector(
		// 			this.publicVars.cssId.headerCls + ' a[data-target="' + this.privateVars.currentMenuItem +
		// 			'"]') as HTMLElement;
		// 		oldHeaderMenuItemHtml.classList.remove(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));
		// 	}
		//
		// 	if(currentMenu !== '' && currentMenu !== 'home__hero') {
		// 		const newHeaderMenuItemHtml = document.querySelector(
		// 			this.publicVars.cssId.headerCls + ' a[data-target="' + currentMenu + '"]') as HTMLElement;
		// 		newHeaderMenuItemHtml?.classList.add(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));
		// 	}
		//
		// 	const currentElementHtml = document.querySelector(
		// 		this.publicVars.cssId.layout.navigateTargetId + '-' + currentMenu) as HTMLElement;
		//
		// 	this.privateVars.currentMenuItem = currentMenu ?? '';
		// 	let metaTitle = currentElementHtml.dataset['meta.title'] ?? '';
		//
		// 	let targetUrl = this.publicVars.baseUrl;
		//
		// 	if (targetUrl.slice(-1) === '/') {
		// 		targetUrl = targetUrl.substring(0, targetUrl.length - 1);
		// 	}
		//
		// 	let trackAdd;
		//
		// 	if (currentMenu && currentMenu !== '' && this.privateVars.items.get(currentMenu)?.config.slug) {
		// 		targetUrl = targetUrl + '/' + this.privateVars.items.get(currentMenu)?.config.slug;
		// 	}
		//
		// 	if (currentMenu && currentMenu !== '' && this.privateVars.items.get(currentMenu)?.config.trackAdd) {
		// 		trackAdd = this.privateVars.items.get(currentMenu)?.config.trackAdd;
		// 	}
		//
		// 	router.route(targetUrl, metaTitle, { disableTrackForUrl: this.publicVars.currentUrl, trackAdd: trackAdd, pageName: 'home' });
		// }
	}

	handleModuleInit(currentScroll: number, key: string, targetPos: {top: number}) {

		if (this.privateVars.items && this.privateVars.items.get(key)?.module && this.privateVars.items.get(key)?.init === false) {
			const navigateTargetHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + key);

			if(!navigateTargetHtml) {
				this.errorMsg('navigate target not found ' + key);
				return;
			}

			const rect = navigateTargetHtml.getBoundingClientRect();
			const scrollPlusWindowHeight = document.documentElement.clientHeight + currentScroll;

			let specialModifier = 0;
			const cssHeaderHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

			if (cssHeaderHtml) {
				specialModifier = cssHeaderHtml.offsetHeight;
			}

			if ((targetPos.top - 200) < scrollPlusWindowHeight &&
				(scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll <
					(targetPos.top + rect.height + specialModifier))) {

				this.fireModuleStart(key);

			}
		}

	}

	fireModuleStart(key: string) {

		const item = this.privateVars.items.get(key);

		if(!item) {
			return;
		}

		if (item.module && !item.init) {
			item.init = true;

			const module = item.module;
			const moduleObj = new module(item.config);
			moduleObj.init();
		}
	}

	performNavigate(target: string, options: {
		easing?: string,
		speed?: number,
		fireAnim?: number,
		detailedJumpTarget?: string,
		finishCallback?: () => void
	}) {

		if(this.privateVars.currentMenuItem !== target) {
			const oldHeaderMenuItemHtml = document.querySelector(
				this.publicVars.cssId.headerCls + ' a[data-target="' + this.privateVars.currentMenuItem +
				'"]') as HTMLElement;
			oldHeaderMenuItemHtml.classList.remove(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));

			const newHeaderMenuItemHtml = document.querySelector(
				this.publicVars.cssId.headerCls + ' a[data-target="' + target + '"]') as HTMLElement;

			newHeaderMenuItemHtml.classList.add(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));
		}

		this.privateVars.targetSection = target;
		this.fireModuleStart(target);

		let easing = (options && options.easing) || 'easeInOutExpo';

		const masterSpeed = (options && options.speed !== undefined && options.speed >= 0) ? options.speed : '';

		const cssHeaderHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;
		let modifier = -cssHeaderHtml.offsetHeight;

		let speed;

		this.privateVars.canNavigateAction = 1;

		const systemCurrentScroll = document.documentElement.scrollTop;

		let targetPos;
		let targetElemHtml;

		if (options.detailedJumpTarget) {
			targetElemHtml = document.querySelector(options.detailedJumpTarget) as HTMLElement;
		} else {
			targetElemHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + target) as HTMLElement;
		}

		if(!targetElemHtml) {
			this.errorMsg('navigate target not found');
			return;
		}

		targetPos = targetElemHtml.getBoundingClientRect();

		let shouldFireAnim = (options && options.fireAnim) || 0;

		let diff = Math.abs(systemCurrentScroll - targetPos.top);

		if (diff > 1000) {
			speed = 600 + (diff / 3);

		} else {
			speed = 800;
		}

		this.msg('diff for navigation ' + diff);

		if (masterSpeed !== '') {
			speed = masterSpeed;
		}

		if (shouldFireAnim === 0) {
			speed = 0;
		}

		this.msg('navigation anim speed ' + speed);

		let jumpTarget;
		let jumpMethod;

		if(!this.service.jump) {
			this.errorMsg('jump service not found');
			return;
		}

		if (options.detailedJumpTarget) {
			jumpTarget = options.detailedJumpTarget;
			jumpMethod = this.service.jump.centerTo;
		} else {
			jumpTarget = this.publicVars.cssId.layout.navigateTargetId + '-' + target;
			jumpMethod = this.service.jump.jumpTo;
		}

		jumpMethod(jumpTarget, {
			modifier: modifier,
			easing: easing,
			speed: speed
		}, () => {

			if (options.finishCallback) {
				options.finishCallback();
			}

			this.privateVars.canNavigateAction = 0;
			this.privateVars.targetSection = '';

			this.handleCurrentScrollPosition({
				target
			});
		});
	}

}

const InvestorsAdvisers = new InvestorsAdvisersPage();
InvestorsAdvisers.init();